import { useState, createContext, useEffect, useContext } from "react";
import { AuthContext } from "./auth-context";
import { auth } from "../firebase";

const DataContext = createContext({
  partner: {},
  fetchData: () => {},
  loadingData: true,
});

export const DataContextProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [partner, setPartner] = useState();
  const [loadingData, setLoadingData] = useState(true);

  const fetchData = async (callback) => {
    try {
      setLoadingData(true);
      // Get authenticated user from firebase auth
      const user = auth.currentUser;
      const idToken = await user.getIdToken();

      // Make a request to the API
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/partner/fetch-partner`,
        {
          method: "POST",
          headers: {
            Authorization: `${process.env.REACT_APP_PARTNER_AUTH_TOKEN}`,
            userid: `${user.uid}`,
            idToken: `${idToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setPartner(data);
      }
      callback && callback();
      setLoadingData(false);
    } catch (err) {
      console.log(err);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (user) fetchData();
    else {
      setPartner();
      setLoadingData(false);
    }
  }, [user]);

  return (
    <DataContext.Provider value={{ partner, fetchData, loadingData }}>
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;
